import _get from 'lodash/get';

export const getCurrentFolderId = (state) => {
  const currentFolder = _get(state, ['documents', 'currentFolder'], {});
  return currentFolder.folderSlug || currentFolder.id;
};

export const selectDuplicateDocumentEnabled = state => _get(state, ['documents', 'duplicateDocumentEnabled']);
